import { Injectable } from '@angular/core';
import { CityFilterService } from './city-filter.service';
import { UtilityService } from './utility.service';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { AirportService } from './airport.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TopFlightsService {

  numadults = 1;
  numchildren = 0;
  numinfants = 0;
  prefclass = "Y";
  prefcarrier = "All";
  numresults = "210";
  fare_type_select = 0;
  private flightSearchData = new BehaviorSubject<any>(null);
  flightSearchData$ = this.flightSearchData.asObservable();
  constructor(private flightDate: CityFilterService, private util: UtilityService , private router: Router, private authService: AuthService,
    private airportService: AirportService
  ) { }

  findAirports(name: string) {
    const cities = name.split(" to ");
    const [originCity, destinationCity] = cities;
    const airportList = JSON.parse(localStorage.getItem('airport') || '[]');
    const findAirport = (city: string) => airportList.find(airport => airport.city_name.trim().toLowerCase() === city.trim().toLowerCase());
    return { originAirport: findAirport(originCity), destinationAirport: findAirport(destinationCity) };
  }

  prepareFlightSearch(name: string) {
    const { nextDayDate } = this.flightDate.calculateDates();
    const { originAirport, destinationAirport } = this.findAirports(name);
    const flight = {
      credentials: this.util.getApiRequestCredentials(),
      trip_selected: 0,
      origin: originAirport.city_code,
      destination: destinationAirport.city_code,
      onwarddate: nextDayDate,
      numadults: this.numadults,
      numchildren: this.numchildren,
      numinfants: this.numinfants,
      prefclass: this.prefclass,
      prefcarrier: this.prefcarrier,
      numresults: this.numresults,
      fare_type_select: this.fare_type_select,
      search_request: {
          origin: originAirport,
          destination : destinationAirport,
          class: []
      }
    };
    localStorage.setItem('flight_search', JSON.stringify(flight));
    // this.router.navigate(['/search']);
    if(this.authService.loggedIn()) {
      this.router.navigate(['./u/flights/search']);
    } else {
      this.router.navigate(['search']);
    }
  }

    findAirportsCode(code: string) {
      const cities = code.split(" to ");
      const [originCodeCity, destinationCodeCity] = cities;
      const airportList = JSON.parse(localStorage.getItem('airport') || '[]');
      const findAirport = (city: string) => airportList.find(airport => airport.city_code.toLowerCase() === city.toLowerCase());
      return { originCodeAirport: findAirport(originCodeCity), destinationCodeAirport: findAirport(destinationCodeCity) };
    }
    
    prepareFlightSearchVisa(code: string) {
      const { nextDayDate } = this.flightDate.calculateDates();
      const { originCodeAirport, destinationCodeAirport } = this.findAirportsCode(code); // Corrected function call
      const flight = {
        credentials: this.util.getApiRequestCredentials(),
        trip_selected: 0,
        origin: originCodeAirport.city_code,
        destination: destinationCodeAirport.city_code,
        onwarddate: nextDayDate,
        numadults: this.numadults,
        numchildren: this.numchildren,
        numinfants: this.numinfants,
        prefclass: this.prefclass,
        prefcarrier: this.prefcarrier,
        numresults: this.numresults,
        fare_type_select: this.fare_type_select,
        search_request: {
            origin: originCodeAirport,
            destination : destinationCodeAirport,
            class: []
        }
      };
      localStorage.setItem('flight_search', JSON.stringify(flight));
      // this.router.navigate(['/search']);
      if(this.authService.loggedIn()) {
        this.router.navigate(['./u/flights/search']);
      } else {
        this.router.navigate(['search']);
      }
    }

  // Domestic Flights Function

  InternationalFlights = [
    {
      imgLoc: 'assets/b2c/flight/most_Search_Flight/bangkok.png',
      origin: { code: 'BKK', name: 'Bangkok' },
      destination: [
        { code: 'BOM', name: 'Mumbai' },
        { code: 'HYD', name: 'Hyderabad'},
        { code: 'PNQ', name: 'Pune' },
        { code: 'PAT', name: 'Patna'},
        { code: 'BLR', name: 'Bengaluru'},
        { code: 'MAA', name: 'Chennai'},
      ],
    },
    {
      imgLoc: 'assets/b2c/flight/most_Search_Flight/dubai.png',
      origin: { code: 'DXB', name: 'Dubai' },
      destination: [
        { code: 'DEL', name: 'New Delhi' },
        { code: 'HYD', name: 'Hyderabad'},
        { code: 'PNQ', name: 'Pune' },
        { code: 'PAT', name: 'Patna'},
        { code: 'BLR', name: 'Bengaluru'},
        { code: 'MAA', name: 'Chennai'},
      ],
    },
    {
      imgLoc: 'assets/b2c/flight/most_Search_Flight/Singapore.png',
      origin: { code: 'SIN', name: 'Singapore'},
      destination: [
        { code: 'DEL', name: 'New Delhi' },
        { code: 'BOM', name: 'Mumbai' },
        { code: 'PNQ', name: 'Pune' },
        { code: 'PAT', name: 'Patna'},
        { code: 'BLR', name: 'Bengaluru'},
        { code: 'MAA', name: 'Chennai'},
      ],
    },
    {
      imgLoc: 'assets/b2c/flight/most_Search_Flight/Bali.png',
      origin: { code: 'DPS', name: 'Denpasar Bali'},
      destination: [
        { code: 'DEL', name: 'New Delhi' },
        { code: 'BOM', name: 'Mumbai' },
        { code: 'PNQ', name: 'Pune' },
        { code: 'PAT', name: 'Patna'},
        { code: 'HYD', name: 'Hyderabad'},
        { code: 'MAA', name: 'Chennai'},
      ],
    },
    {
      imgLoc: 'assets/b2c/flight/most_Search_Flight/New_york.png',
      origin: { code: 'NYC', name: 'New York' },
      destination: [
        { code: 'DEL', name: 'New Delhi' },
        { code: 'BOM', name: 'Mumbai' },
        { code: 'BLR', name: 'Bengaluru'},
        { code: 'HYD', name: 'Hyderabad'},
        { code: 'MAA', name: 'Chennai'},
      ],
    },
    {
      imgLoc: 'assets/b2c/flight/most_Search_Flight/Paris.png',
      origin: { code: 'PAR', name: 'Paris'},
      destination: [
        { code: 'DEL', name: 'New Delhi' },
        { code: 'BOM', name: 'Mumbai' },
        { code: 'BLR', name: 'Bengaluru'},
        { code: 'HYD', name: 'Hyderabad'},
        { code: 'PNQ', name: 'Pune' },
      ],
    }
  ]


  domesticFlights = [
    {
      imgLoc: 'assets/b2c/flight/most_Search_Flight/new_delhi.png',
      origin: { code: 'DEL', name: 'New Delhi' },
      destination: [
        { code: 'BOM', name: 'Mumbai' },
        { code: 'HYD', name: 'Hyderabad'},
        { code: 'PNQ', name: 'Pune' },
        { code: 'PAT', name: 'Patna'},
        { code: 'BLR', name: 'Bengaluru'},
        { code: 'MAA', name: 'Chennai'},
      ],
    },
    {
      imgLoc: 'assets/b2c/flight/most_Search_Flight/mumbai.png',
      origin: { code: 'BOM', name: 'Mumbai' },
      destination: [
        { code: 'DEL', name: 'New Delhi' },
        { code: 'HYD', name: 'Hyderabad'},
        { code: 'PNQ', name: 'Pune' },
        { code: 'PAT', name: 'Patna'},
        { code: 'BLR', name: 'Bengaluru'},
        { code: 'MAA', name: 'Chennai'},
      ],
    },
    {
      imgLoc: 'assets/b2c/flight/most_Search_Flight/hyderabad.png',
      origin: { code: 'HYD', name: 'Hyderabad'},
      destination: [
        { code: 'DEL', name: 'New Delhi' },
        { code: 'BOM', name: 'Mumbai' },
        { code: 'PNQ', name: 'Pune' },
        { code: 'PAT', name: 'Patna'},
        { code: 'BLR', name: 'Bengaluru'},
        { code: 'MAA', name: 'Chennai'},
      ],
    },
    {
      imgLoc: 'assets/b2c/flight/most_Search_Flight/banglore.png',
      origin: { code: 'BLR', name: 'Bengaluru'},
      destination: [
        { code: 'DEL', name: 'New Delhi' },
        { code: 'BOM', name: 'Mumbai' },
        { code: 'PNQ', name: 'Pune' },
        { code: 'PAT', name: 'Patna'},
        { code: 'HYD', name: 'Hyderabad'},
        { code: 'MAA', name: 'Chennai'},
      ],
    },
    {
      imgLoc: 'assets/b2c/flight/most_Search_Flight/pune.png',
      origin: { code: 'PNQ', name: 'Pune' },
      destination: [
        { code: 'DEL', name: 'New Delhi' },
        { code: 'BOM', name: 'Mumbai' },
        { code: 'BLR', name: 'Bengaluru'},
        { code: 'HYD', name: 'Hyderabad'},
        { code: 'MAA', name: 'Chennai'},
      ],
    },
    {
      imgLoc: 'assets/b2c/flight/most_Search_Flight/chennai.png',
      origin: { code: 'MAA', name: 'Chennai'},
      destination: [
        { code: 'DEL', name: 'New Delhi' },
        { code: 'BOM', name: 'Mumbai' },
        { code: 'BLR', name: 'Bengaluru'},
        { code: 'HYD', name: 'Hyderabad'},
        { code: 'PNQ', name: 'Pune' },
      ],
    }
  ]

  findAirportsDomestic(originCode: string, destinationCode: string) {
    const airportList = JSON.parse(localStorage.getItem('airport') || '[]');
    const findAirport = (city: string) => airportList.find(airport => airport.city_code.toLowerCase() === city.toLowerCase());
    return { originAirport: findAirport(originCode), destinationAirport: findAirport(destinationCode) };
  }

  prepareFlightSearchDomestic(originCode: string, destinationCode: string) {
    const { nextDayDate } = this.flightDate.calculateDates();
    const { originAirport, destinationAirport } = this.findAirportsDomestic(originCode, destinationCode); // Corrected function call
    const flight = {
      credentials: this.util.getApiRequestCredentials(),
      trip_selected: 0,
      origin: originAirport.city_code,
      destination: destinationAirport.city_code,
      onwarddate: nextDayDate,
      numadults: this.numadults,
      numchildren: this.numchildren,
      numinfants: this.numinfants,
      prefclass: this.prefclass,
      prefcarrier: this.prefcarrier,
      numresults: this.numresults,
      fare_type_select: this.fare_type_select,
      search_request: {
          origin: originAirport,
          destination : destinationAirport,
          class: []
      }
    };
    localStorage.setItem('flight_search', JSON.stringify(flight));
    // this.router.navigate(['../search']);
    if(this.authService.loggedIn()) {
      this.router.navigate(['./u/flights/search']);
    } else {
      this.router.navigate(['search']);
    }

    // Additional logic for flight search...
  }


  findAirportsDomestic__(originCode: string, destinationCode: string) {
    const airportList = JSON.parse(localStorage.getItem('airport') || '[]');
    const findAirport = (city: string) => airportList.find(airport => airport.city_code.toLowerCase() === city.toLowerCase());
    return { originAirport: findAirport(originCode), destinationAirport: findAirport(destinationCode) };
  }

  prepareFlightSearchDomestic__(originCode: string, destinationCode: string) {
    this.airportService.fetchAndStoreAirports()
    .then(() => {
    const { nextDayDate } = this.flightDate.calculateDates();
    const { originAirport, destinationAirport } = this.findAirportsDomestic(originCode, destinationCode); // Corrected function call
    const flight = {
      credentials: this.util.getApiRequestCredentials(),
      trip_selected: 0,
      origin: originAirport.city_code,
      destination: destinationAirport.city_code,
      onwarddate: nextDayDate,
      numadults: this.numadults,
      numchildren: this.numchildren,
      numinfants: this.numinfants,
      prefclass: this.prefclass,
      prefcarrier: this.prefcarrier,
      numresults: this.numresults,
      fare_type_select: this.fare_type_select,
      search_request: {
          origin: originAirport,
          destination : destinationAirport,
          class: []
      }
    };
    localStorage.setItem('flight_search', JSON.stringify(flight));
    // Additional logic for flight search...
    }).catch(() => {
      console.error('Unable to prepare flight search due to missing airport data.');
    });
  }


  findAirports___(name: string) {
    const cities = name.split(" to ");
    const [originCity, destinationCity] = cities;
    const airportList = JSON.parse(localStorage.getItem('airport') || '[]');
    const findAirport = (city: string) => airportList.find(airport => airport.city_name.trim().toLowerCase() === city.trim().toLowerCase());
    return { originAirport: findAirport(originCity), destinationAirport: findAirport(destinationCity) };
  }

  prepareFlightSearch___(name: string) {
    const { nextDayDate } = this.flightDate.calculateDates();
    const { originAirport, destinationAirport } = this.findAirports(name);
    const flight = {
      credentials: this.util.getApiRequestCredentials(),
      trip_selected: 0,
      origin: originAirport.city_code,
      destination: destinationAirport.city_code,
      onwarddate: nextDayDate,
      numadults: this.numadults,
      numchildren: this.numchildren,
      numinfants: this.numinfants,
      prefclass: this.prefclass,
      prefcarrier: this.prefcarrier,
      numresults: this.numresults,
      fare_type_select: this.fare_type_select,
      search_request: {
          origin: originAirport,
          destination : destinationAirport,
          class: []
        }
      };
    localStorage.setItem('flight_search', JSON.stringify(flight));
    this.flightSearchData.next(flight);
    // this.router.navigate(['/search']);
    // if(this.authService.loggedIn()) {
    //   this.router.navigate(['./u/flights/search']);
    // } else {
    //   this.router.navigate(['search']);
    // }
  }

  loadFromStorage() {
    const savedData = localStorage.getItem('flight_search');
    if (savedData) {
      this.flightSearchData.next(JSON.parse(savedData));
    } else {
      this.flightSearchData.next({}); // or [] based on your need
    }
  }
}
